module.exports = __webpack_public_path__ + "img/Danielle-McAvoy.4b18b97d.jpeg";